import { cn } from '@pokerly/ui';
import { cva, type VariantProps } from 'class-variance-authority';

export { default as GameCard } from './GameCard.vue';

export const gameCardVariants = cva(cn(), {
    variants: {
        variant: {
            default: '',
            brand: '',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

const cardStyles = [
    'absolute',
    'border-2',
    'border-border-border-0',
    'rounded-lg',
    'w-full',
    'h-full',
    'flex',
    'justify-center',
    'items-center',
    'backface-hidden',
];

export const gameCardBackVariants = cva(cn(...cardStyles, 'shadow-[0_0_8.75px_0_rgba(0,0,0,0.17)]'), {
    variants: {
        variant: {
            default: cn(
                'bg-radial-[71.43%_50%_at_50%_50%]',
                'from-surface-accent-0 from-0%',
                'via-surface-accent-2 via-59.13%',
                'to-surface-accent-3 to-100%',
            ),
            brand: cn(
                'bg-radial-[50%_50%_at_50%_50%]',
                'from-[rgba(37,43,55,0.00)]',
                'from-60.1%',
                'to-[rgba(37,43,55,0.10)]',
                'to-100%',
                'bg-patilla-800',
            ),
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
export const gameCardFrontVariants = cva(
    cn(
        ...cardStyles,
        'rotate-y-180',
        'bg-surface-accent-3',
        'opacity-100',
        'select-none',
        'font-extrabold',
        'uppercase',
        'group-hover/game-card:bg-surface-accent-0',
    ),
    {
        variants: {
            variant: {
                default: cn(
                    'text-foreground-primary',
                    'group-data-[selected=true]/game-card:text-foreground-on-primary',
                    'group-data-[selected=true]/game-card:bg-patilla-500',
                ),

                // 'background: radial-gradient(71.43% 50% at 50% 50%, var(--surface-accent-0, #FFF) 0%, var(--surface-accent-2, #F3F4F6) 59.13%, var(--surface-accent-3, #E5E7EB) 100%);',
                brand: cn('text-foreground-brand', 'group-data-[selected=true]/game-card:bg-surface-muted'),
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export type GameCardVariants = VariantProps<typeof gameCardVariants>;
